module.exports = __webpack_public_path__ + "static/media/3-BLASTELL.3b882ada.mp3";